import axios from '../../axios';
import * as TYPES from '../types';

const state = {
  cashflows: [],
  cashflowDetail: null
};
const getters = {
  cashflows: state => state.cashflows,
  cashflowDetail: state => state.cashflowDetail,
};
const mutations = {
  [TYPES.SET_CASHFLOWS](state, payload) {
    state.cashflows = payload;
  },
  [TYPES.SET_CASHFLOW_DETAIL](state, payload) {
    state.cashflowDetail = payload;
  }
};
const actions = {
  /**
   * 获取现金流量表
   * @param commit
   */
  getCashflows: ({commit}) => {
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/cashflows",{params:{sort:'companyId,desc'}})
      .then(response => {
        commit(TYPES.SET_CASHFLOWS, response.data.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },

  /**
   * 获取现金流量表详情
   * @param commit
   * @param balanceSheetId
   */
  getCashflowDetail: ({commit}, cashflowId) => {
    commit(TYPES.SET_CASHFLOW_DETAIL, null);
    commit(TYPES.SET_LOADING, true);
    axios
      .get("/cashflows/" + cashflowId)
      .then(response => {
        commit(TYPES.SET_CASHFLOW_DETAIL, response.data);
        commit(TYPES.SET_LOADING, false);
      })
      .catch(reason => {
        commit(TYPES.SET_ERROR, reason.message);
        commit(TYPES.SET_LOADING, false);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}